import type { ProposalStatus } from "../../shared/types";

export const statusLabels: Record<ProposalStatus, string> = {
  draft: "Draft",
  sent: "Sent",
  viewed: "Viewed",
  accepted: "Accepted",
  paid: "Paid",
  cold: "Cold",
  archived: "Archived",
};

export function StatusBadge({ status }: { status: ProposalStatus }) {
  return <span className={`status status--${status}`}>{statusLabels[status]}</span>;
}
